<template>

  <div id="page-user-list">
    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="pagidropdown border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ listData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : listData.length }} of {{ listData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          
          <vs-input class="teacherSearchBtn sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
         
         
          
          <vs-button @click="addList" class="mt-0 mr-2 shadow-lg" type="gradient" color="primary"  icon-pack="feather" icon="icon-menu" icon-after>Add List</vs-button>
        
      </div>
      <div class = "flex flex-wrap items-center mt-3" >
       
        <v-select 
          :options="categoryOptions"  
          :clearable="false" 
          :dir="$vs.rtl ? 'rtl' : 'ltr'" 
          v-model="categoryFilter" 
          class="categorySearchStatus mb-4 mr-2 md:mb-0"
        />
       

    
      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="listData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import axios from "@/axios.js"

// Store Module
import moduleLearningHub from '@/store/learninghub/moduleLearningHub.js'

import CellRendererLink from "./cell-renderer-list/CellRendererLink.vue"

export default {
  components: {
    AgGridVue,
    vSelect,
    CellRendererLink,
  },
  data() {
    return {

      categoryFilter: { label: 'Category - All', value: 'all' },
      categoryOptions: [
        { label: 'Category - All', value: 'all' },

      ],

      // Filter Options
      roleFilter: { label: 'All', value: 'all' },
      searchQueryDateFrom: '',
      searchQueryDateTo: '', 
      statusFilter: { label: 'Status - All', value: 'all' },
      isVerifiedFilter: { label: 'Email - All', value: 'all' },
      departmentFilter: { label: 'All', value: 'all' },
      searchQuery: "",

      // AgGrid
      gridApi: null,
      gridOptions: {
        onRowDragEnd: this.onRowDragEnd,  // Highlighted: Handling row drag end
      },
      defaultColDef: {
        filterable: false,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
      {
          headerName: 'Sort',
          field: 'id',
          width: 80,
          filter: false,
          checkboxSelection: false,
          headerCheckboxSelectionFilteredOnly: false,
          headerCheckboxSelection: false,
          rowDrag: true,  // Highlighted: Enable row dragging
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 80,
          filter: false,
          checkboxSelection: false,
          headerCheckboxSelectionFilteredOnly: false,
          headerCheckboxSelection: false,
        },
        {
          headerName: 'Title',
          field: 'title_en',
          filter: false,
          width: 300,
          autoHeight: true,
          cellRenderer: function(param){
            return param.data.title_en + '<br/>' + param.data.title_da;
          }
        },
        {
          headerName: 'Description',
          field: 'description_en',
          filter: false,
          width: 300,
          autoHeight: true,
          cellRenderer: function(param){
            return param.data.description_en + '<br/>' + param.data.description_da;
          }
        },
        {
          headerName: 'Categories',
          field: 'categories',
          filter: false,
          width: 300,
          autoHeight: true,
          cellRenderer: function(param){
          
            return param.data.category.name_en + '<br/>' + param.data.category.name_da;
          }
        },
        {
          headerName: 'Actions',
          field: 'id',
          filter: false,
          width: 115,
          cellRendererFramework: 'CellRendererLink'
        },
      ],

      components: {
        CellRendererLink,
      }

    }
  },
  watch: {
    categoryFilter(newFilter) {
        console.log('triggerd watch');
        console.log(newFilter);
      this.filterByCategory(newFilter.value);
    }
  },
  computed: {
    listData() {
      return this.$store.state.learninghubManagement.list
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    truncateLabel(label) {
      console.log('truncate', label);
      const maxLength = 10; // Adjust as needed
      return label.length > maxLength ? `${label.slice(0, maxLength)}...` : label;
    },
    populateCategoryOptions() {
      const categoriesSet = new Set(); // Ensure unique categories
      const categoryIdMap = new Map(); // Map to store category IDs

      this.listData.forEach(item => {
        const category = item.category;
        if (category && category.id) {
          categoriesSet.add(category.name_en);
          categoryIdMap.set(category.name_en, category.id); // Map name to ID
        }
      });

      this.categoryOptions = [
        { label: 'Category - All', value: 'all' },
        ...Array.from(categoriesSet).map(category => ({
          label: category,
          value: categoryIdMap.get(category) // Use ID here
        }))
      ];
    },

    // Call this method after the data is loaded, e.g., after fetching listData
    fetchData() {
      this.$store.dispatch("learninghubManagement/fetchList")
        .then(() => {
          this.populateCategoryOptions(); // Populate categories after data is fetched
          this.gridApi.setRowData(this.listData); // Ensure grid is populated
        })
        .catch(err => { console.log(err) });
    },

    filterByCategory(categoryId) {
      console.log('Filtering by category ID:', categoryId); // Debug
      if (categoryId === 'all') {
        // Show all data if "Category - All" is selected
        this.gridApi.setRowData(this.listData);
      } else {
        // Filter the data by the selected category ID
        const filteredData = this.listData.filter(item =>
          item.category && item.category.id === categoryId
        );
        console.log('Filtered Data:', filteredData); // Debug
        this.gridApi.setRowData(filteredData);
      }
    },

    // Highlighted: Handle row dragging and swapping
    onRowDragEnd(event) {
      const movedItem = event.node.data;
      const overIndex = event.overIndex;

      // Remove the dragged item from its original position
      const oldIndex = this.listData.findIndex(item => item.id === movedItem.id);
      this.listData.splice(oldIndex, 1);

      // Insert the dragged item at its new position
      this.listData.splice(overIndex, 0, movedItem);
      
      // Define a new array to store the IDs
      const idsArray = this.listData.map(item => item.id);

      // Convert the array to a comma-separated string
      const orderString = idsArray.join(',');

      // Log the new order string
      console.log('Updated Order:', orderString);

       // Send the updated order to the server
         this.updateOrder(orderString);

      // Refresh the grid data
      this.gridApi.setRowData(this.listData);
      // console.log('update',this.listData);
    },
    updateOrder(orderString) {
      const token = localStorage.getItem("accessToken");

      axios.post('https://backend.heyway.com/api/learninghub/updateorder', 
        { ids: orderString }, // Send data as JSON
        { headers: { 
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json' // Set Content-Type header
        }}
      )
      .then(response => {
        console.log('Order updated successfully:', response.data);
      })
      .catch(error => {
        console.error('Error updating order:', error);
      });
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if(val !== "all") {
        modelObj = { type: "equals", filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }
      
      this.categoryFilter = { label: 'Category - All', value: 'all' }

      this.searchQueryDateFrom = ''
      this.searchQueryDateTo = ''

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    addList() {
            this.$router.push("/learninghublisting/add").catch(() => {})
        },
  },
  mounted() {
    // this.gridApi = this.gridOptions.api
    this.gridApi = this.$refs.agGridTable.gridOptions.api; // Use $refs to get gridApi reference
    this.fetchData();
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
  },
  created() {
    if(!moduleLearningHub.isRegistered) {
        console.log('is registered not');
      this.$store.registerModule('learninghubManagement', moduleLearningHub)
      moduleLearningHub.isRegistered = true
    }
    this.fetchData(); // Fetch data and populate categories on component creation
    this.$store.dispatch("learninghubManagement/fetchList").catch(err => { console.log(err) })
  }
}

</script>



<style type="text/css">

.pagidropdown{
    padding: 11px!important;
}

.rounded-full {
    border-radius: 7px !important;
}

.teacherSearchBtn{
  width: 34% ! important;
}

.teacherSearchStatus{
  width: 17% ! important;
}

.teacherSearchEmail{
  width: 17% ! important;
}

.categorySearchStatus{
  width: 350px ! important;
  
}
.selected-item {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  width: 300px !important;
} 
.vs__selected {
  width: 300px ! important;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
}
.vs__search{
  display: none;
}
@media only screen and (max-width: 450px){
  .categorySearchStatus{
    width: 300px !important;

  }
  .vs__selected {
    width: 260px !important;
  }
}


</style>